import { FeedbackForm } from "@/pages/quiz/base/questions/contactField/feedbackForm";
import Footer from "@/components/Footer";
import Logo from "@/components/Logo";
import clsx from "clsx";

const FeedbackPageView = () => {
  return (
    <div
      className={clsx(
        "flex flex-col h-full min-h-[100vh] justify-between",
        "bg-violet-100"
      )}
    >
      <header>
        <div className="h-20 flex justify-center items-center bg-dark-purple-2">
          <Logo wrapperClassName="text-white max-w-[150px]" />
        </div>
      </header>

      <div
        className={clsx(
          "bg-white w-full sm:w-618 p-[16px_16px_24px] sm:p-[30px_75px_60px] sm:drop-shadow-[0_3px_4px_rgba(0,0,0,0.25)] mx-auto mb-20",
          "mt-10 max-w-[calc(100%-32px)] rounded-xl"
        )}
      >
        <FeedbackForm />
      </div>
      <Footer />
    </div>
  );
};

export default FeedbackPageView;
